import * as yup from "yup";

export const validations = yup.object({
  email: yup.string().required("Wajib diisi"),
  password: yup.string().required("Wajib diisi"),
});
